function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCurvedArrow = function SvgCurvedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.016 60.543"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M44.9 30.6a16.1 16.1 0 0 1 4.3.7c6.8 2 18.1 10.2 18.7 41.4l5.8-5.8 1.4 1.4-8.2 8.2-8.2-8.2 1.4-1.4 5.8 5.8c-.6-31-12.2-37.9-17.2-39.4a22.111 22.111 0 0 0-2.5-.5c.3.7.5 1.3.7 1.8 1.5 5.7-1.7 11.4-5.6 13.4-3.1 1.6-6.4.8-9-2.3-2.3-2.7-2.4-6-.4-9.1a14.934 14.934 0 0 1 10.4-6c-3.4-3.3-9.6-5-17.9-4.7l-.1-2c12.3-.3 18 3.3 20.6 6.7zm-11.2 7.2a5.365 5.365 0 0 0 .2 6.7c1.9 2.3 4.2 2.9 6.5 1.8 3.2-1.6 5.7-6.5 4.5-11.2a8.657 8.657 0 0 0-1-2.4c-4.5.1-8.4 2.3-10.2 5.1z",
    style: {
      fill: "#ff5001",
      stroke: "#ff5001"
    },
    transform: "rotate(8 182.82 -104.749)"
  }));
};
export default SvgCurvedArrow;